<template>
  <div id="WorkOrderEstimateView">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
         <div class="page-name">
            <div class="page-title">Customer Estimate View</div>
            <!-- Button for Clear Cache -->
            <clear-cache-data :pageKey="[pageKey,subKey1]" ></clear-cache-data>
            <template v-if="canListWorkOrderEstimate == true">
              <div class="web-action-btn btn-groups text-right">
                <a href="javascript:void(0)" class="btn btn-primary" v-on:click="viewCustEstTemplate"> <i class="fp-download"> </i> Download</a>
                <a href="javascript:void(0)" class="btn btn-primary" v-on:click="sendCustomerEstimation"> <i class="fp-invoice"> </i> Send Estimation</a>
                <button type="submit" class="btn btn-secondary pull-right ml-1" v-on:click.prevent="goPreviousList" >
                  <i class="fp-back"> </i>    Back
                </button>
              </div>
              <div class="mobile-action-btn elipse-btn">
              <button type="submit" class="btn btn-secondary pull-right ml-1" v-on:click.prevent="goPreviousPath" >
                  <i class="fp-back"> </i>    Back
                </button>
                <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="true" v-on:click.prevent="myFunction">
                    <i class="fp-ellipsis-v"></i>
                </button>
                <ul  id="myDropdown" class="dropdown-content">
                    <li>
                        <a href="javascript:void(0)" v-on:click="viewCustEstTemplate"> Download</a>
                    </li>
                    <li>
                        <a href="javascript:void(0)" v-on:click="sendCustomerEstimation"> Send Estimation</a>
                    </li>
                </ul>
              </div>
            </template>
          </div>
          <div class="container-fluid">
            <div class="admin-page-content estimate-view list-view">
              <section class="internal-container">
                <div id="tabs" class="containerTab mt-3">
                  <div class="tabs">
                    <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Customer Estimate Details</a>
                    <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity Log</a>
                  </div>
                  <div class="content">
                    <div v-show="activetab === 1" class="tabcontent">
                      <div class="list-sections">
                          <div class="form-row no-divider">
                            <div class="col-md-6">
                              <div class="row form-group">
                                <label class="col">#Estimate :</label>
                                <span class="col">{{titleCase(workOrderEstimateNoInfo)}}</span>
                              </div>
                              <div class="row form-group">
                                <label class="col">Customer :</label>
                                <span class="col">{{customerInfo}}</span>
                              </div>
                              <div class="row form-group">
                                <label class="col">Unit :</label>
                                <span class="col">{{assetInfo}}</span>
                              </div>
                              <div class="row form-group">
                                <label class="col">Status :</label>
                                <span class="col">{{woStatusInfo}}</span>
                              </div>
                              <div class="row form-group">
                                <label class="col">Notes :</label>
                                <span class="col">{{woNotesInfo}}</span>
                              </div>
                              <div class="row form-group">
                                <label class="col">User :</label>
                                <span class="col">{{userInfo}}</span>
                              </div>
                              <div class="row form-group">
                                <label class="col">Maintenance Type :</label>
                                <span class="col">{{maintenanceTypeInfo}}</span>
                              </div>
                            </div>
                            <div class="col-md-6">
                                <div class="row form-group" v-if="miscFlag==true">
                                  <label class="col">Is Miscellaneous :</label>
                                  <span class="col">{{miscellaneousInfo}}</span>
                                </div>
                                <div class="row form-group" v-if="miscFlag==true">
                                  <label class="col">Customer Unit No :</label>
                                  <span class="col">{{cusUnitNoInfo}}</span>
                                </div>
                                <div class="row form-group" v-if="miscFlag==true">
                                  <label class="col">Email :</label>
                                  <span class="col">{{emailInfo}}</span>
                                </div>
                                <div class="row form-group" v-if="miscFlag==true">
                                  <label class="col">Vin No :</label>
                                  <span class="col">{{vinNoInfo}}</span>
                                </div>
                                <div class="row form-group">
                                  <label class="col">Open Date :</label>
                                  <span class="col">{{openDateInfo}}</span>
                                </div>
                                <div class="row form-group">
                                  <label class="col">Expiry Date :</label>
                                  <span class="col">{{expiryDateInfo}}</span>
                                </div>
                                <div class="row form-group">
                                  <label class="col">Location :</label>
                                  <span class="col">{{locationInfo}}</span>
                                </div>
                                <div class="row form-group">
                                <label class="col">Miles :</label>
                                <span class="col">{{milesInfo}}</span>
                              </div>
                            </div>
                          </div>
                          <div class="btn-groups text-right mt-4" v-if="woStatusInfo.toLowerCase() != 'approved'">
                              <button type="submit" id="editWorkOrderEstimateBtn" v-on:click="editWorkOrderEstimate()" class="btn btn-primary" ><i class="fp-edit-icon"></i>  Edit
                              </button>
                          </div>
                      </div>
                    </div>
                    <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                        <estimate-activity-log-list :activityLogVal="activityLogsTabValue"></estimate-activity-log-list>
                    </div>
                  </div>
                </div>
                <template v-if="activetab === 1">
                  <template v-if="taskArr.length == 0">
                    <div class="bg-white">
                      <h3>No Line Item Added</h3>
                    </div>
                  </template>
                  <template v-else>
                  <div class="bg-white mt-4" v-for="(task, index) in taskArr" :key="index">
                      <h5 class="font-semibold">Line Item {{index + 1}}</h5>
                      <div class="list-sections">
                        <div class="form-row no-divider">
                          <div class="col-md-4">
                            <div class="row form-group">
                              <label class="col"> VMRS: </label>
                              <span class="col" v-if="task.component_category_id != null"> {{task.component_category_id.text}} </span>
                              <span class="col" v-else> - </span>
                            </div>
                            <div class="row form-group">
                              <label class="col"> Task :</label>
                              <span class="col" v-if="task.taskid != null"> {{task.taskid.text}}</span>
                              <span class="col" v-else> - </span>
                            </div>
                            <div class="row form-group">
                              <label class="col"> Reason: </label>
                              <span class="col" v-if="task.wi_reason_id != '-'"> {{task.wi_reason_id.text}} </span>
                              <span class="col" v-else> {{task.wi_reason_id}} </span>
                            </div>
                          </div>
                          <div class="col-md-4">
                              <div class="row form-group">
                                <label class="col"> Part Fail: </label>
                                <span class="col" v-if="task.defect_id != '-'"> {{task.defect_id.text}} </span>
                                <span class="col" v-else> {{task.defect_id}} </span>
                              </div>
                              <div class="row form-group">
                                <label class="col"> Complaint: </label>
                                <span class="col"> {{task.woicomplaint}} </span>
                              </div>
                              <div class="row form-group">
                                <label class="col"> Cause: </label>
                                <span class="col"> {{task.woicause}} </span>
                              </div>
                          </div>
                          <div class="col-md-4">
                            <div class="row form-group">
                              <label class="col"> Correction: </label>
                              <span class="col"> {{task.woicorrection}} </span>
                            </div>
                            <div class="row form-group">
                              <label class="col"> Is sublet: </label>
                              <span class="col" v-if="task.issublet == 1"> Yes </span>
                              <span class="col" v-else> No </span>
                            </div>
                          </div>
                        </div>
                        <div class="labor-part-section mt-5">
                          <div class="labor-view-section">
                            <h4> <i class="fp-settings"></i> Labors </h4>
                            <div class="table-responsive-sm">
                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                              <thead>
                                <tr class="table-primary">
                                  <th scope="col"> Technician </th>
                                  <th scope="col"> Description </th>
                                  <th scope="col"> Hours </th>
                                  <th scope="col"> Rate </th>
                                  <th scope="col"> Total </th>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-if="task.hasLabor === true">
                                <tr v-for="(labor, laborIndex) in laborArr" :key="laborIndex">
                                  <template v-if="labor.service_task_id.index == index">
                                    <td> <span class="labor-name-wo"> </span> <span v-if="labor.laborid != null">{{labor.laborid.text}}</span> <span v-else>-</span> </td>
                                    <td> {{labor.labordescription}} </td>
                                    <td> {{labor.laborhours}} Hrs </td>
                                    <td> ${{labor.laborhourrate.toFixed(2)}} </td>
                                    <td> ${{labor.laborsubtotal.toFixed(2)}} </td>
                                  </template>
                                </tr>
                                </template>
                                <template v-else>
                                  <tr> <td colspan="4" class="no-data-field"> No Labors Available </td></tr>
                                </template>
                              </tbody>
                            </table>
                            </div>
                          </div>
                          <div class="labor-view-section mt-5">
                            <h4> <i class="fp-settings"></i> Labor Hours </h4>
                            <div class="table-responsive-sm">
                              <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                <thead>
                                  <tr class="table-primary">
                                    <th scope="col"> Technician </th>
                                    <th scope="col"> Date </th>
                                    <th scope="col"> Hours </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <template v-if="task.hasLabor === true">
                                  <tr v-for="(laborHr, laborHrInd) in laborHourArr" :key="laborHrInd">
                                    <template v-if="laborHr.service_task_id.index == index">
                                      <td> <span class="labor-name-wo"> </span> <span v-if="laborHr.laborid != null">{{laborHr.laborid.text}}</span> <span v-else>-</span> </td>
                                      <td> {{laborHr.date_added}} </td>
                                      <td> {{laborHr.hours}} </td>
                                    </template>
                                  </tr>
                                  </template>
                                  <template v-else>
                                    <tr> <td colspan="3" class="no-data-field"> No Labor Hours Available </td></tr>
                                  </template>
                                </tbody>
                              </table>
                            </div>
                          </div>      
                          <div class="part-view-section mt-5">
                            <h4> <i class="fp-settings"></i> Parts </h4>
                            <div class="table-responsive-sm">
                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                              <thead>
                                <tr class="table-primary">
                                  <th> Name  </th>
                                  <th> Description </th>
                                  <th> Qty </th>
                                  <th> Rate </th>
                                  <th> Total </th>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-if="task.hasComponent === true">
                                <tr v-for="(comp, componentIndex) in componentArr" :key="componentIndex">
                                  <template v-if="comp.service_task_id.index == index">
                                  <td> {{comp.compid.text}}  </td>
                                  <td> {{comp.compdescription}}  </td>
                                  <td> {{comp.compquantity.toFixed(2)}}  </td>
                                  <td> ${{comp.compcost.toFixed(2)}} </td>
                                  <td> ${{comp.compsubtotal.toFixed(2)}} </td>
                                  </template>
                                </tr>
                                </template>
                                <template v-else>
                                  <td colspan="5" class="no-data-field"> No Parts Available </td>
                                </template>
                              </tbody>
                            </table>
                            </div>
                          </div>
                          <div class="comment-view-section mt-5">
                            <h4> <i class="fp-faq"></i> Comments </h4>
                            <div class="labor-part-view comment-view">
                              <ul class="comment-box clearfix">
                                <template v-if="task.hasComment=== true">
                                  <template v-for="(comment,commentIndex) in commentArr">
                                    <template v-if="comment.service_task_id.index == index">
                                        <li :key="commentIndex">
                                            <span class="labor-icon"> {{ comment.wocBy.substring(0,2).toUpperCase() }} </span>
                                            <div class="comment-details">
                                                <div class="comment-dec"><span class="user">{{comment.wocBy}}</span>({{comment.wocType.text}}) <span>{{comment.wocAt}}</span> </div>
                                                <p>{{comment.woc}}</p>
                                            </div>
                                        </li>
                                    </template>
                                  </template>
                                </template>
                                <template v-else>
                                  <p>No Comments Available</p>
                                </template>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
                  </template>
                  <div class="order-summary mt-4 mb-4">
                      <div class="row">
                          <div class="col-md-6 offset-md-6">
                            <div class="bg-white radius-5 p-3">
                              <label> SUMMARY </label>
                              <table aria-describedby="table" class="table table-sm table-bordered">
                                <tbody>
                                  <tr class="table-secondary">
                                        <td>Labor:</td>
                                        <td class="text-right">${{laborAmount.toFixed(2)}}</td>
                                    </tr>
                                    <tr>
                                        <td>Parts:</td>
                                        <td class="text-right">${{componentAmount.toFixed(2)}}</td>
                                    </tr>
                                    <tr class="table-secondary">
                                        <td>Subtotal:</td>
                                        <td class="text-right">${{subTotal.toFixed(2)}}</td>
                                    </tr>
                                    <tr>
                                        <td>Shop Supplies:</td>
                                        <td class="text-right">${{shop_supplies.toFixed(2)}}</td>
                                    </tr>
                                    <tr>
                                        <td>Other Charges:</td>
                                        <td class="text-right">${{other_charges.toFixed(2)}}</td>
                                    </tr>
                                    <tr>
                                        <td>Sales Tax:</td>
                                        <td class="text-right">${{taxAmount.toFixed(2)}}</td>
                                    </tr>
                                    <tr>
                                        <td>Total:</td>
                                        <td class="order-total text-right">${{total.toFixed(2)}}</td>
                                    </tr>
                                </tbody>
                              </table>
                            </div>
                      </div>
                    </div>
                </div>
                </template>
          </section>
          </div>
        </div>
      </template>

      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>Oops!</h1>
            <h2>403</h2>
            <div class="error-details">Sorry!, You don't have permission to access this page.</div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer><!--tab content--><!--tab content-->
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import { commonMixins } from "../mixins/commonMixins";

import ActivityLogListView from '@/components/ActivityLogList.vue';
Vue.component("estimate-activity-log-list", ActivityLogListView);
export default {
  name: "WorkOrderEstimateView",
  mixins: [commonMixins],
  data: () => ({
    firstLoad: 0,
    permissions: [],
    cantAccessPage: "",
    canListWorkOrderEstimate:false,
    loading: false,
    workOrderEstimateNoInfo:'',
    assetInfo:'',
    customerInfo:'',
    openDateInfo:'',
    requestCompInfo:'',
    agreedDateInfo:'',
    userInfo:'',
    woStatusInfo:'',
    milesInfo:'',
    locationInfo:'',
    priorityInfo:'',
    woNotesInfo:'',
    maintenanceTypeInfo:'',
    expiryDateInfo:'',
    scheduleMaintenanceInfo:'',
    laborAmount:0,
    componentAmount:0,
    subTotal:0,
    discount:0,
    discountAmount:0,
    tax:0,
    taxAmount:0,
    total:0,
    taskArr:[],
    laborArr:[],
    componentArr:[],
    commentArr:[],
    activityArr:[],
    serviceTaskArr:[],
    custId:'',
    activetab: 1,
    activityLogsTabValue: "dontLoadList",
    activityLoaded:false,
    pageKey:"",
    subKey1:"",
    other_charges:0,
    shop_supplies:0,
    miscFlag:false,
    miscellaneousInfo:"",
    cusUnitNoInfo:"",
    emailInfo:"",
    vinNoInfo:"",
    laborHourArr:[]

  }),
  watch: {
    //check permission change
    permissions: function(permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == "view_customer_estimate") {
            self.cantAccessPage = true;
          }
          if (permissions[i].name == "list_customer_estimate") {
            self.canListWorkOrderEstimate = true;
          }
        }
      }
    },
    laborArr:{
      handler: function(newValue) {
          var self = this;

          for ( var i = 0; i < self.serviceTaskArr.length; i++ ) {

              var labor = false;
              var serviceTaskIdx = self.serviceTaskArr[i].index;

              for ( var j = 0; j < newValue.length; j++ ) {

                  if(newValue[j].service_task_id != null){

                      var taskIdx = newValue[j].service_task_id.index;

                      if(taskIdx == serviceTaskIdx){

                          labor = true;

                      }

                  }
              }

              self.taskArr[serviceTaskIdx].hasLabor = labor;

          }
      },
      deep: true
    },
    componentArr:{
      handler: function(newValue) {
          var self = this;

          for ( var i = 0; i < self.serviceTaskArr.length; i++ ) {

              var component = false;
              var serviceTaskIdx = self.serviceTaskArr[i].index;

              for ( var j = 0; j < newValue.length; j++ ) {

                  if(newValue[j].service_task_id != null){

                      var taskIdx = newValue[j].service_task_id.index;

                      if(taskIdx == serviceTaskIdx){

                          component = true;

                      }

                  }
              }

              self.taskArr[serviceTaskIdx].hasComponent = component;

          }
      },
      deep: true
    },
    commentArr: {
        handler: function(newValue) {
            var self = this;

            for ( var i = 0; i < self.serviceTaskArr.length; i++ ) {

                var comment = false;
                var serviceTaskIdx = self.serviceTaskArr[i].index;

                for ( var j = 0; j < newValue.length; j++ ) {

                    if(newValue[j].service_task_id != null){

                        var taskIdx = newValue[j].service_task_id.index;

                        if(taskIdx == serviceTaskIdx){

                            comment = true;

                        }

                    }
                }

                self.taskArr[serviceTaskIdx].hasComment = comment;

            }
        },
        deep: true
    }
  },
  created: function() {},
  mounted: function() {
    var self = this;
    self.getPermissions();
    self.loadWorkOrderEstimate();
    var path = window.location.pathname;
    var segments = path.split("/");
    self.pageKey='_customer_estimate_view_'+segments[3];
    self.subKey1='_customer_estimate_item_view_'+segments[3];
  },
  metaInfo() {
    return {
      title: (this.workOrderEstimateNoInfo != "") ? this.workOrderEstimateNoInfo + " | Customer Estimate View | " +process.env.COPYRIGHT_NAME:"Customer Estimate View | " +process.env.COPYRIGHT_NAME
    }
  },
  methods: {
    goPreviousList: function(){
      var self = this;
      if (self.$route.params.redirectFrom != undefined && self.$route.params.redirectFrom == 'MaintenanceSchedule'){
        self.$router.push("/maintenance-schedule");
      }else{
        self.$router.push("/estimate");
      }
    },
    editWorkOrderEstimate(){
      var path = window.location.pathname;
      var segments = path.split("/");
      var self = this;
      self.$router.push("/customer-estimate/edit/" + segments[3]);
    },
    loadWorkOrderEstimate() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;


        let wo_id = (segments[3] != undefined)?segments[3]:self.woId;

        $.ajax({
            url: process.env.ROOT_API + "/customer-estimate/" + wo_id,
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {

                  var storeObject={visited_page: {
                                    path : "customer-estimate |" +data.content.work_order_estimate_no,
                                    data : window.location.pathname,
                                    }};
                    self.getRecentlyPagesMethod(storeObject);

                    if(data.content.is_miscellaneous == 1){
                      self.miscFlag = true;
                        self.miscellaneousInfo = "Yes";
                        self.emailInfo = data.content.customer_email;
                        self.vinNoInfo = data.content.customer_vin_number;
                        self.cusUnitNoInfo = data.content.customer_unit_no;
                    }else{
                      self.miscFlag = false;
                    }

                    self.workOrderEstimateNoInfo = data.content.work_order_estimate_no;
                    if(data.content.vehicle_id != null){
                      self.assetInfo = data.content.vUnitNo + " | " + data.content.vtCode + " | " + data.content.vName;
                    }else{
                      self.assetInfo = "-";
                    }

                    if(data.content.open_date != null){
                        self.openDateInfo = data.content.open_date;
                    }else{
                        self.openDateInfo = "-";
                    }
                    if(data.content.requested_completion != null){
                        self.requestCompInfo = data.content.requested_completion;
                    }else{
                        self.requestCompInfo = "-";
                    }
                    if(data.content.agreed_date != null){
                        self.agreedDateInfo = data.content.agreed_date;
                    }else{
                        self.agreedDateInfo = "-";
                    }
                    if(data.content.expiry_date != null){
                        self.expiryDateInfo = data.content.expiry_date;
                    }else{
                        self.expiryDateInfo = "-";
                    }

                    self.customerInfo = self.titleCase(data.content.cusCode) + " | " + data.content.cusName;
                    if(data.content.uLastName != null){
                        self.userInfo = self.titleCase(data.content.uFirstName) + " " + self.titleCase(data.content.uLastName);
                    }else{
                        self.userInfo = self.titleCase(data.content.uFirstName);
                    }

                    if ( data.content.priority ) {
                        self.priorityInfo = data.content.priorityName + " (" + data.content.priority + ")";
                    } else {
                        self.priorityInfo = "-";
                    }

                    self.woStatusInfo = self.titleCase(data.content.status);
                    self.milesInfo = data.content.miles;
                    /*if(data.content.schedule_maintenance_id != null){
                        if(data.content.schedule_date != null){
                            self.scheduleMaintenanceInfo = data.content.vUnitNo + " (" + data.content.schedule_date + ")";
                        }else{
                            self.scheduleMaintenanceInfo = data.content.vUnitNo + " ()";
                        }
                    }else{
                        self.scheduleMaintenanceInfo = "-";
                    }*/
                    self.maintenanceTypeInfo = self.titleCase(data.content.maintenanceTypeName);
                    self.wostatus = {value: data.content.status, text: self.formatString(data.content.status)};
                    if(data.content.lState != null){
                        self.locationInfo = data.content.lName + ", " + data.content.lState + " | " + data.content.lCode;
                    }else{
                        self.locationInfo = data.content.lName + " | " + data.content.lCode;
                    }

                    self.woNotesInfo = data.content.description;

                    self.laborAmount = data.content.labor_amount;
                    self.componentAmount = data.content.component_amount;
                    self.subTotal = data.content.sub_amount;
                    self.discount = data.content.discount;
                    self.discountAmount = data.content.discount_amount;
                    self.tax = data.content.tax;
                    self.taxAmount = data.content.tax_amount;
                    self.total = data.content.total_amount;
                    self.custId = data.content.customer_id;
                    self.other_charges = data.content.other_charges;
                    self.shop_supplies = data.content.shop_supplies;
                    self.workOrderEstimateItemData();

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR, false, 'customer-estimate-view');
            }
        });
    },
    workOrderEstimateItemData() {

        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");

        let wo_id = (segments[3] != undefined)?segments[3]:self.woId;

        $.ajax({
            url: process.env.ROOT_API + "/customer-estimate/get-customer-estimate-item",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType:"json",
            data:{
                work_order_id: wo_id,
            },
            success: function (data) {

                if (data.code == 200) {

                    self.taskArr = [];
                    self.componentArr = [];
                    self.laborArr = [];
                    self.commentArr = [];
                    self.activityArr = [];
                    self.laborHourArr = [];

                    if(data.content.item != undefined){
                        self.serviceTaskArr = []

                        for ( var i=0; i<data.content.item.length; i++ ) {

                            self.taskArr.push({

                                // wo_id: (data.content[i].wo_id != undefined && data.content[i].wo_id != null && data.content[i].wo_id != '')?data.content[i].wo_id:0,
                                woiId: (data.content.item[i].wo_item_id != undefined && data.content.item[i].wo_item_id != null && data.content.item[i].wo_item_id != '')?data.content.item[i].wo_item_id:0,
                                taskid: (data.content.item[i].task_id != undefined && data.content.item[i].task_id != null && data.content.item[i].task_id != '')?{value: data.content.item[i].task_id, text: self.titleCase(data.content.item[i].task_name + " (" + data.content.item[i].task_code +")")}:null,
                                laboramount: data.content.item[i].labor_amount,
                                partamount: data.content.item[i].component_amount,
                                component_category_id: (data.content.item[i].component_category_id != undefined && data.content.item[i].component_category_id != null && data.content.item[i].component_category_id != '')?{value: data.content.item[i].component_category_id, text: self.titleCase(data.content.item[i].component_category_name + " (" + data.content.item[i].component_category_code +")")}:null,
                                wi_reason_id: (data.content.item[i].wi_reason_id != undefined && data.content.item[i].wi_reason_id != null && data.content.item[i].wi_reason_id != '')?{value: data.content.item[i].wi_reason_id, text: self.titleCase(data.content.item[i].wi_reason_name + " (" + data.content.item[i].wi_reason_code +")")}:"-",
                                defect_id: (data.content.item[i].standard_defect_id != undefined && data.content.item[i].standard_defect_id != null && data.content.item[i].standard_defect_id != '')?{value: data.content.item[i].standard_defect_id, text: self.titleCase(data.content.item[i].standard_defect_name + " (" + data.content.item[i].standard_defect_code +")")}:"-",
                                woicomplaint: data.content.item[i].complaint,
                                woicause: data.content.item[i].cause,
                                woicorrection: data.content.item[i].correction,
                                workOrderItemId: (data.content.item[i].work_order_item_id != undefined && data.content.item[i].work_order_item_id != null && data.content.item[i].work_order_item_id != '')?data.content.item[i].work_order_item_id:0,
                                issublet:data.content.item[i].issublet


                                // subtotal: 0,
                                // hasLabor: false,
                                // hasComp: false

                            });

                            self.serviceTaskArr.push({value: (data.content.item[i].task_id != undefined && data.content.item[i].task_id != null && data.content.item[i].task_id != '')?data.content.item[i].task_id:null, text: data.content.item[i].task_name, index: self.taskArr.length-1});

                        }
                    }

                    if(data.content.comp != undefined){
                        for ( var i=0; i<data.content.comp.length; i++ ) {

                            self.componentArr.push({
                                cid: (data.content.comp[i].cid != undefined && data.content.comp[i].cid != null && data.content.comp[i].cid != '')?data.content.comp[i].cid:0,
                                compid: {value: data.content.comp[i].compid, text:data.content.comp[i].compname},
                                service_task_id: {value: data.content.comp[i].service_task_id, text:data.content.comp[i].service_task_name, index: data.content.comp[i].service_task_index},
                                compcost: data.content.comp[i].compcost,
                                compquantity: data.content.comp[i].compquantity,
                                compsubtotal: data.content.comp[i].compsubtotal,
                                compdescription: (data.content.comp[i].compdescription != null && data.content.comp[i].compdescription != '' )?data.content.comp[i].compdescription:"-",
                                workOrderCompId: (data.content.comp[i].work_order_component_id != undefined && data.content.comp[i].work_order_component_id != null && data.content.comp[i].work_order_component_id != '')?data.content.comp[i].work_order_component_id:0,
                            });

                        }
                    }

                    if(data.content.comment != undefined){
                        for ( var i=0; i<data.content.comment.length; i++ ) {

                            self.commentArr.push({
                                wocId: (data.content.comment[i].wocId != undefined && data.content.comment[i].wocId != null && data.content.comment[i].wocId != '')?data.content.comment[i].wocId:0,
                                service_task_id: {value: data.content.comment[i].service_task_id, text:data.content.comment[i].service_task_name, index: data.content.comment[i].service_task_index},
                                wocType: {value: data.content.comment[i].wocTypeId, text:self.titleCase(data.content.comment[i].wocTypeName)+' ('+data.content.comment[i].wocType+')'},
                                woc: data.content.comment[i].woc,
                                wocBy: data.content.comment[i].wocBy,
                                wocAt: data.content.comment[i].wocAt,
                                woCommentId: (data.content.comment[i].work_order_comment_id != undefined && data.content.comment[i].work_order_comment_id != null && data.content.comment[i].work_order_comment_id != '')?data.content.comment[i].work_order_comment_id:0
                            });

                        }
                    }

                    if(data.content.labor != undefined){
                        for ( var i=0; i<data.content.labor.length; i++ ) {

                            self.laborArr.push({
                                lid: (data.content.labor[i].lid != undefined && data.content.labor[i].lid != null && data.content.labor[i].lid != '')?data.content.labor[i].lid:0,
                                laborid: (data.content.labor[i].laborid != undefined && data.content.labor[i].laborid != null && data.content.labor[i].laborid != '') ? {
                                        value: data.content.labor[i].laborid,
                                        text: data.content.labor[i].laborname
                                    } : null,
                                service_task_id: {value: data.content.labor[i].service_task_id, text:data.content.labor[i].service_task_name, index: data.content.labor[i].service_task_index},
                                laborhours: data.content.labor[i].laborhours,
                                laborhourrate: data.content.labor[i].laborhourrate,
                                laborsubtotal: data.content.labor[i].laborsubtotal,
                                labordescription: (data.content.labor[i].labordescription != null && data.content.labor[i].labordescription != '' )?data.content.labor[i].labordescription:"-",
                                workOrderLaborId: (data.content.labor[i].work_order_labor_id != undefined && data.content.labor[i].work_order_labor_id != null && data.content.labor[i].work_order_labor_id != '')?data.content.labor[i].work_order_labor_id:0,
                            });

                        }
                    }

                    //crm activity for work order
                    if(data.content.activity != undefined){
                        for ( var i=0; i<data.content.activity.length; i++ ) {

                            self.activityArr.push({
                                woeiId:(data.content.activity[i].ewoiId != undefined && data.content.activity[i].ewoiId != null && data.content.activity[i].ewoiId != '')?data.content.activity[i].ewoiId:0,
                                crmId:(data.content.activity[i].crmId != undefined && data.content.activity[i].crmId != null && data.content.activity[i].crmId != '')?data.content.activity[i].crmId:0,
                                service_task_index: data.content.activity[i].service_task_index,
                                activity_type: data.content.activity[i].activity_type,
                                notes: (data.content.activity[i].notes != null && data.content.activity[i].notes != undefined && data.content.activity[i].notes != '')?data.content.activity[i].notes:'',
                                activityBy: data.content.activity[i].activityBy,
                                activityAt: data.content.activity[i].activityAt,
                            });
                        }
                    }

                    if(data.content.labor_hours != undefined){
                        for ( var i=0; i<data.content.labor_hours.length; i++ ) {

                            self.laborHourArr.push({
                                lid: (data.content.labor_hours[i].lid != undefined && data.content.labor_hours[i].lid != null && data.content.labor_hours[i].lid != '')?data.content.labor_hours[i].lid:0,
                                laborid: (data.content.labor_hours[i].laborid != undefined && data.content.labor_hours[i].laborid != null && data.content.labor_hours[i].laborid != '') ? {
                                        value: data.content.labor_hours[i].laborid,
                                        text: data.content.labor_hours[i].laborname
                                    } : null,
                                service_task_id: {value: data.content.labor_hours[i].service_task_id, text:data.content.labor_hours[i].service_task_name, index: data.content.labor_hours[i].service_task_index},
                                hours: data.content.labor_hours[i].hours,
                                date_added: data.content.labor_hours[i].date_added,
                            });

                        }
                    }

                } else if( data.code == 201 ) {

                    console.log('No line item is assigned with wo..');


                }
            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR, true, 'customer-estimate-items-view');
            }
        });
    },
    titleCase(str) {
      if ( str == null ) {
        return "-";
      } else {
        var value = str.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    },
    formatString(data) {
        var self = this;
        var value = data.replace(/_/g, " ");
        var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
            return letter.toUpperCase();
        });
        return upp;
    },

    sendCustomerEstimation(){
      var self = this;

      if ( self.wostatus.value != 'open'){

        if (confirm('Customer estimate has already been sent. Do you want to send it again? ')) {
          self.sendCustEst();
        }

      } else {

          self.sendCustEst();
      }
    },

    sendCustEst: function(){
      var self =  this;

      var path = window.location.pathname;
      var segments = path.split("/");
      var field = [];
      field[0] = {};
      field[0]['id'] = segments[3];
      field[0]['cust_id'] = self.custId;

      $.ajax({
            url: process.env.ROOT_API + '/customer-estimate/send',
            type: "POST",
            data: {
              arr:field,
              flag:"send"
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {

                self.loading = false;
                self.$swal('',data.content,'success');
                self.loadWorkOrderEstimate();
              // self.$router.push('/customer-estimate/view/'+data.content);
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR, true, 'customer-estimate-send-from-view');
            }
        });
    },
    viewCustEstTemplate(){

      var self = this;
      var path = window.location.pathname;
      var segments = path.split("/");
      self.loading = true;

      $.ajax({
          url: process.env.ROOT_API + "/get-cust-est-template",
          type: "GET",
          data: {id:segments[3],
          flag:'Send with item',
          cust_id:self.cust_id,
          task:'download'},
          headers: this.ajxHeaders,
          success: function (data) {
              self.loading = false;

              var link = document.createElement('a');
              document.body.appendChild(link);
              link.href = data;
              link.download = '';
              link.target = "_blank";
              link.click();

          },
          error: function (jqXHR, exception) {
              self.loading = false;
              self.modalLoading = false;
              self.reqeustSent = 0;

              self.loading = false;
              self.generateStatusCodeMessage(jqXHR, true, 'get-customer-estimate-template');
          }
      });

    },
    activityLogs(){

      var self = this;
      var path = window.location.pathname;
      var segments = path.split("/");

      self.$root.$emit('activity_log_opted','customer estimate',segments[3]);
      self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
      self.activetab = 2;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/CustomerEstimateView.vue